import { styled } from '@mui/material/styles';

export const AnimatedImageStyled = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  pointer-events: none;
  user-select: none;

  & > div {
    width: 100%;
    height: 100%;
  }
`;
